import { Editor } from '@tinymce/tinymce-react';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Field } from 'redux-form';
import { TINYAPI } from '../../../../env';
import TextArea from '../TextArea';
import styles from './styles.scoped.css';
import { uploadImageFaq } from '../../../utils/api';

export function RichTextInput({
  name,
  value,
  label,
  initialValue,
  required,
  input,
}) {
  const [errorUpload, setErrorUpload] = useState('');

  const fileToBase64 = (val) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(val);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const uploadImageCallBack = async (blobInfo, success, failure) => {
    try {
      const file = blobInfo?.blob();
      setErrorUpload('');
      if (!file) {
        if (failure) failure('No file received for upload');
        return;
      }
      if (file.size > 2000000) {
        const msg = 'Maksimal Ukuran file 2 MB';
        setErrorUpload(msg);
        if (failure) failure(msg);
        return;
      }
      const base64 = await fileToBase64(file);
      const params = {
        image: base64,
      };
      const data = await uploadImageFaq(params);
      const url = data?.data?.link;
      if (url) {
        success(url);
      } else {
        const msg = 'Upload succeeded but no URL returned';
        setErrorUpload(msg);
        if (failure) failure(msg);
      }
    } catch (error) {
      const msg = 'Image upload gagal';
      setErrorUpload(msg);
      if (failure) failure(msg);
    }
  };

  const _handleEditorChange = (e) => {
    input.onChange(e.target.getContent());
  };
  return (
    <div className={styles['input-group']}>
      <label>{label}</label>
      {required && <span className={styles.withAsterisk}> *</span>}

      <Editor
        apiKey={TINYAPI}
        init={{
          height: 300,
          menubar: true,
          config: {},
          images_upload_credentials: true,
          plugins: [
            'advlist autolink lists link image charmap print preview anchor',
            'searchreplace visualblocks code fullscreen',
            'insertdatetime media table paste code help wordcount',
          ],
          toolbar: `link code image | formatselect | bold italic backcolor | \
            alignleft aligncenter alignright alignjustify | \
            bullist numlist outdent indent | removeformat | help`,
          image_title: true,
          automatic_uploads: true,
          file_picker_types: 'image',
          images_upload_handler: uploadImageCallBack,
        }}
        initialValue={initialValue}
        onChange={_handleEditorChange}
        // value={value}
      >
        <Field component={TextArea} inputProps={value} name={name} {...input} />
      </Editor>
      <span style={{ color: '#EA2036' }}>{errorUpload}</span>
    </div>
  );
}

export default RichTextInput;

RichTextInput.propTypes = {
  errorUpload: PropTypes.string,
  initialValue: PropTypes.string,
  input: PropTypes.object,
  label: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
  uploadImageCallBack: PropTypes.func,
  value: PropTypes.string,
};
